import script from "./QCustomFab.vue?vue&type=script&setup=true&lang=ts"
export * from "./QCustomFab.vue?vue&type=script&setup=true&lang=ts"

import "./QCustomFab.vue?vue&type=style&index=0&id=7b81e766&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b81e766"]])

export default __exports__
import QSpace from 'quasar/src/components/space/QSpace.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSpace,QPageSticky,QBtn});
